import { PROFIT_WALLET } from "../lib/contract";
import { ImagePanel } from "./ImagePanel";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-ink-1000">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-16">
        {/* Shin-chan in the pool — playful CTA panel */}
        <ImagePanel
          src="/images/download.jpg"
          alt="Shin-chan floating in the pool"
          className="aspect-[16/7] mb-12"
          filter="saturate(1.1) brightness(0.95)"
        >
          <div className="flex h-full items-end p-8 md:p-12">
            <div className="max-w-xl">
              <div className="eyebrow mb-3"><span className="dot" />come on in</div>
              <div className="font-display text-3xl md:text-5xl tracking-tight">
                the water's <span className="font-serif italic text-aurora">fine</span>.
              </div>
              <div className="font-mono text-xs text-bone-dim mt-3 max-w-md">
                21,000 slots, 100k GAIA each, 0.001 ETH per slot. fair launch, locked LP, AI-mintable.
              </div>
            </div>
          </div>
        </ImagePanel>

        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-12">
          <div>
            <div className="flex items-center gap-3">
              <span className="size-9 rounded-2xl bg-gradient-to-br from-teal-300 via-teal-400 to-leaf" />
              <span className="font-display text-2xl">GAIA</span>
            </div>
            <p className="mt-4 max-w-md text-bone-dim text-sm leading-relaxed">
              Mother nature's memecoin. Public mint, hard 5 ETH profit cap, then locked Uniswap v4
              LP forever. Mintable by humans and AI agents.
            </p>
          </div>
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-bone-dim mb-4">links</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#mint"      className="hover:text-teal-300 transition-colors">Mint</a></li>
              <li><a href="#waterfall" className="hover:text-teal-300 transition-colors">Split</a></li>
              <li><a href="#mcp"       className="hover:text-teal-300 transition-colors">AI mint via MCP</a></li>
              <li><a href="#roadmap"   className="hover:text-teal-300 transition-colors">Roadmap</a></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-bone-dim mb-4">on chain</div>
            <ul className="space-y-2 text-sm font-mono">
              <li>
                <a href={`https://etherscan.io/address/${PROFIT_WALLET}`} target="_blank" rel="noreferrer"
                   className="hover:text-teal-300 transition-colors">
                  Profit wallet ↗
                </a>
              </li>
              <li>
                <a href="https://sepolia.etherscan.io/address/0x30bd231c010b2d377A32102AE072D93EE1EA892B"
                   target="_blank" rel="noreferrer"
                   className="hover:text-teal-300 transition-colors">
                  Sepolia GAIA ↗
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="hairline" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-bone-dim">
        <div>© GAIA — memecoin. no utility promised. read the contract.</div>
        <div className="font-mono">made for the only home we've got.</div>
      </div>
    </footer>
  );
}
